import TickIcon from '../../assets/images/success.png';
import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Snackbar,
  Alert,
  useTheme,
  DialogActions,
  TextField
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import SignInDialog from "../SignInDialog";
import PaymentForm from "../PaymentForm";
import { useUser } from "../../context/UserContext";
import axios from 'axios';
interface GiftCardListProps {
  events: {
    imageUrl: string;
    title: string;
    description: string;
    price: string;
    giftcardId: string;
  }[];
}
interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
}
const purchaseGiftCard = async (body: any): Promise<any> => {
  const url = `${process.env.REACT_APP_BASE_API_URL}/v1/purchase-giftcard`;
  const token = localStorage.getItem('authToken');

  try {
    const response = await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error creating booking:', error);
    throw new Error('Failed to create booking');
  }
};
const GiftCardList: React.FC<GiftCardListProps> = ({ events }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { user, setUser } = useUser();

  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [showPayment, setShowPayment] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const [platform, setPlatform] = useState('');
  const [receiverName, setReceiverName] = useState('');
  const [receiverEmail, setReceiverEmail] = useState('');
  const [receiverMessage, setReceiverMessage] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);

  const handleBuyNowClick = async (event: any) => {
    if (user) {
      setSelectedItem(event);
      setIsModelOpen(true);
    } else {
      // setIsDialogOpen(true);
      setSelectedItem(event);
      setIsDialogOpen(true);
    }
  };

  const validateInputs = (): boolean => {
    if (!receiverName.trim()) {
      setError('Name is required.');
      return false;
    } else if (/\d/.test(receiverName)) {
      setError('Name should not include numbers');
      return false;
    }

    // const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!receiverEmail.trim()) {
      setError('Email is required.');
      return false;
    }

    if (!emailPattern.test(receiverEmail)) {
      setError('Invalid email format.');
      return false;
    }

    if (receiverMessage.length > 260) {
      setError('Message must be 260 characters or less.');
      return false;
    }

    // Clear error if validation passes
    setError(null);
    return true;
  };

  const handleConfirmAndPay = async (selectedItem: any) => {
    console.log("Selected item:", selectedItem); // Debugging line
    if (validateInputs()) {
      if (user && selectedItem) {
        setShowPayment(true);
        setSelectedCard(selectedItem);
        console.error("Selected item is missing or invalid.");
      }
    }
  };

  const handlePaymentSuccess = async () => {
    setShowPayment(false);
    setSuccess(true);
    setIsModelOpen(false);
    const userData: any = localStorage.getItem("user");
    const userInfo = JSON.parse(userData);
    const body = {
      userId: userInfo.userId,
      giftCardId: selectedCard.giftcardId,
      receiverName,
      receiverEmail,
      receiverMessage
    };
    try {
      console.log("body=======2>", body);

      let response = await purchaseGiftCard(body);
      console.log("purchaseGiftCard response =>", response);
    } catch (err) {
      console.error("Error in purchasing gift card:", err);
      setError("Payment error occurred.");
    }
  };

  const handlePaymentError = (errorMessage: string) => {
    setShowPayment(false);
    setError(errorMessage);
  };

  const handleCloseSuccess = () => {
    setReceiverName('');
    setReceiverEmail('');
    setReceiverMessage('');
    setSuccess(false);
    setSelectedCard(null);
  };
  const handleDialogClose = () => {
    setReceiverName('');
    setReceiverEmail('');
    setReceiverMessage('');
    setIsModelOpen(false);
  };
  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('windows') !== -1) {
      setPlatform('windows');
    } else if (userAgent.indexOf('mac') !== -1) {
      setPlatform('mac');
    } else if (userAgent.indexOf('linux') !== -1) {
      setPlatform('linux');
    } else {
      setPlatform('unknown');
    }
    const userData: any = localStorage.getItem("userInfo");
    const userInfo = JSON.parse(userData);
    setUser(userInfo);
  }, [setUser]);

  const handleSignInSuccess = async (userInfo: any) => {
    const userData = JSON.stringify(userInfo);
    localStorage.setItem("userInfo", userData);
    setUser(userInfo);
    const data = {
      userHandle: userInfo.name.replace(/ /g, ''),
      firstName: userInfo.given_name,
      lastName: userInfo.family_name,
      email: userInfo.email.toLowerCase(),
      identities: [
        {
          identityType: 'Google',
          identityValue: userInfo.id,
        },
      ],
      operatingSystem: platform,
    };
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_API_URL}/v1/user/createUser`, data);
      if (response.status === 201 || response.status === 200) {
        const responseData = response.data;
        localStorage.setItem("user", JSON.stringify(responseData));
        localStorage.setItem('authToken', responseData.token);
        if (selectedItem) {
          setIsModelOpen(true);
        }
      }
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };

  const handleErrorAlertClose = () => {
    setApiError(null);
  };

  const truncateDescription = (text: string, limit: number = 150): string =>
    text.length > limit ? `${text.slice(0, limit)}...` : text;

  return (
    <Box sx={{ margin: isMobile ? '100px 10px' : 15 }}>
      <Grid container spacing={3}>
        {events.map((event, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Box
              sx={{
                borderRadius: "8px",
                overflow: "hidden",
                backgroundColor: "background.paper",
                // boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)",
                marginTop: 1,
                margin: isMobile ? 0 : '20px'
              }}
            >
              <Box
                sx={{
                  borderRadius: "8px",
                  position: "relative",
                  // width: "100%",
                  cursor: "pointer",
                }}
              >
                <Box
                  component="img"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                  src={event.imageUrl}
                  alt={event.title}
                />
              </Box>

              <Box sx={{ padding: 2 }}>
                <Typography variant="h6">{event.title}</Typography>
                {/* <Typography variant="body1" sx={{ marginTop: 1 }}>
                  {truncateDescription(event.description)}
                </Typography>
                <Typography variant="body2" sx={{ marginTop: 1 }}>
                  {event.price}
                </Typography> */}
                <Button
                  variant="contained"
                  sx={{
                    marginTop: 2,
                    maxWidth: {
                      xs: '100%',  // Mobile phones
                      md: '60%',   // Small laptops
                    },
                    backgroundColor: "#2D3178",
                    color: "white",
                    borderRadius: "5px",
                    padding: "8px 16px",
                    textTransform: "none",
                    fontSize: "0.95rem",
                    whiteSpace: "nowrap",
                    "&:hover": { backgroundColor: "darkgrey" },
                  }}
                  onClick={() => handleBuyNowClick(event)}
                >
                  Buy Now
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      {/* Input Modal for Name, Email, and Message */}
      {isModelOpen && (
        <Dialog open={isModelOpen} onClose={handleDialogClose} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ pb: 1 }}>
            Enter the Recipient’s Details
          </DialogTitle>
          <DialogContent sx={{ px: 3, pb: 1 }}>
            <TextField
              label="Recipient Name"
              fullWidth
              value={receiverName}
              onChange={(e) => setReceiverName(e.target.value)}
              sx={{ my: 1.5 }}
            />
            <TextField
              label="Recipient Email"
              fullWidth
              value={receiverEmail}
              onChange={(e) => setReceiverEmail(e.target.value)}
              sx={{ my: 1.5 }}
            />
            <TextField
              label="Message (Optional)"
              fullWidth
              value={receiverMessage}
              onChange={(e) => setReceiverMessage(e.target.value)}
              multiline
              rows={4}
              sx={{ my: 1.5 }}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              onClick={handleDialogClose}
              sx={{
                width: isMobile ? "100px" : "30%",
                color: "white",
                borderRadius: "5px",
                padding: "8px 12px",
                textTransform: "none",
                fontSize: "0.95rem",
                backgroundColor: "gray",
                "&:hover": { backgroundColor: "darkgrey" },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => handleConfirmAndPay(selectedItem)}
              sx={{
                width: isMobile ? "150px" : "30%",
                backgroundColor: "#2D3178",
                color: "white",
                borderRadius: "5px",
                padding: "8px 12px",
                textTransform: "none",
                fontSize: "0.95rem",
                "&:hover": { backgroundColor: "darkgrey" },
              }}
            >
              Confirm & Pay
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Payment Modal */}
      {showPayment && (
        <Dialog open={showPayment} onClose={() => setShowPayment(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Payment</DialogTitle>
          <DialogContent>
            <PaymentForm
              amount={selectedCard?.price}
              onSuccess={handlePaymentSuccess}
              onError={handlePaymentError}
            />
          </DialogContent>
        </Dialog>
      )}

      {/* Success Modal */}
      {success && <SuccessDialog open={success} onClose={handleCloseSuccess} />}

      {/* Error Modal */}
      {error && (
        <Snackbar
          open={!!error}
          autoHideDuration={6000}
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: isMobile ? '75%' : '100%' }}>
            {error}
          </Alert>
        </Snackbar>
      )}

      <SignInDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSignInSuccess={handleSignInSuccess}
      />
    </Box>
  );
};

const SuccessDialog: React.FC<SuccessDialogProps> = ({ open, onClose }) => {
  const userData: any = localStorage.getItem("userInfo");
  const userInfo = JSON.parse(userData);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleHomeClick = () => {
    onClose()
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      // maxWidth="xs" 
      style={{ width: isMobile ? '350px' : '430px', margin: '0 auto' }}
      fullWidth
    >
      <DialogTitle sx={{ textAlign: "center" }}>Success</DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: "center", padding: 3 }}>
          <img
            src={TickIcon}
            alt="Success"
            style={{
              height: 150,
              width: 150,
              objectFit: "contain",
              marginBottom: 50,
            }}
          />
          <Typography variant="h6">
            Congratulations, {userInfo?.name}! Your purchase was successful.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={handleHomeClick}
            sx={{
              width: 150,
              marginTop: 3,
              backgroundColor: "#2D3178",
              color: "white",
            }}
          >
            OK
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default GiftCardList;
